export const ENEMY_ARCHETYPES = {
    forestSprite: {
        id: "forestSprite",
        name: "Forest Sprite",
        maxHealth: 60,
        damage: 6,
        moveSpeed: 3.5,
        detectionRadius: 10,
        attackRange: 2.2,
        leashRadius: 22,
        attackIntervalMs: 1500,
        experienceReward: 35,
        respawnDelayMs: 12000,
        patrolRadius: 6,
        patrolIntervalMs: 4000,
    },
};
//# sourceMappingURL=enemies.js.map